import React from 'react';
import ReactDOM from 'react-dom';
import NavBarComponent from '../nav/NavBarComponent-Itay'

class SalesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      name: '',
      email: '',
      submitted: false
    };
  }

  componentDidMount(){
    document.title = 'Trybe | Best way for fitness creators to launch a workout app';
  }

  onClickStart = () => {
    window.open(
      'https://trybesl.typeform.com/to/nyjnzF3P',
      '_blank'
    )
  }

  onEnterName = (e) => {
    const text = e.target.value;
    this.setState({ name: text });
  }

  onEnterEmail = (e) => {
    const text = e.target.value;
    this.setState({ email: text });
  }

  onClickSubmit = () => {
    this.props.actions.signUpActions.submitEmail(this.state.email, this.state.name);
    this.setState({submitted: true});
  }

  onClickCloseModal = () => {
    this.setState({
      submitted: false,
      showModal: false
    });
  }

  onClickApp = () => {
    window.open(
      'https://trybe.app.link/IZIgC3aYUS',
      '_blank'
    )
  }

  render() {
    return (
      <div className='sales-page-container'>
        <NavBarComponent/>
        <div className='hero-section'>
          <div className='hero-bg-img'/>
          <div className='content'>
            <div className='primary-area'>
              <div className='primary-text'>Fitness creators, get your app</div>
              <div className='secondary-text'>Earn sustainable revenues with your workouts.</div>
              <button
                type='button'
                className='start-button'
                onClick={ this.onClickStart }>
                GET STARTED
              </button>
            </div>
            <div className='secondary-area'>
              <img
                src={require('../../images/hero-secondary.png')}
                className='hero-secondary-img'
              />
            </div>
          </div>
        </div>
        <div className='testim-section'>
          <div className='testim-title'>What our creators are saying</div>
          <div className='testim-cards-container'>
          <div className='testim-card'>
            <div className='testim-text'>
              "Working with Trybe has been great. They're always helping me find solutions and enabled me to <strong>multiply</strong> my monthly revenue from digital products."
            </div>
            <div className='testim-bottom'>
              <div className='testim-card-line' />
                <a
                  className='testim-person-row'
                  href='https://www.youtube.com/channel/UCU0DZhN-8KFLYO6beSaYljg'
                  target='_blank'>
                <img
                    src={'https://res.cloudinary.com/dljcvcx8l/image/upload/v1586204134/Tom_Icon_lsge3u.jpg'}
                  className='testim-person-img'
                />

                <div className='testim-person-signature'>
                    <div className='testim-link-row'>
                    <div className='testim-person-name'>Tom Merrick</div>
                    <img
                      src={require('../../images/yt-icon.png')}
                      className='testim-yt-icon'
                    />
                  </div>
                  <div className='testim-person-descr'>Bodyweight Warrior</div>
                </div>
              </a>
            </div>
          </div>
            <div className='testim-card'>
              <div className='testim-text'>
                "Trybe has been a dream come true! Vince made this process so easy while working alongside with him. Trybe is so user friendly, and life is a lot easier when you have Trybe to conquer the world with."
              </div>
              <div className='testim-bottom'>
                <div className='testim-card-line' />
                <a
                  className='testim-person-row'
                  href='https://www.instagram.com/ArianeAndrew/'
                  target='_blank'>
                  <img
                    src={'https://res.cloudinary.com/dljcvcx8l/image/upload/v1586204911/ariane_icon_ogtzhn.jpg'}
                    className='testim-person-img'
                  />
                  <div className='testim-person-signature'>
                    <div className='testim-link-row'>
                      <div className='testim-person-name'>Ariane Andrew</div>
                      <img
                        src={require('../../images/ig-icon.png')}
                        className='testim-ig-icon'
                      />
                    </div>
                    <div className='testim-person-descr'>Double AAcademy</div>
                  </div>
                </a>
              </div>
            </div>
            <div className='testim-card'>
              <div className='testim-text'>
                "It's been a great experience working with Trybe. The team is hard working, kind, friendly and results oriented."
              </div>
              <div className='testim-bottom'>
                <div className='testim-card-line' />
                <a
                  className='testim-person-row'
                  href='https://www.youtube.com/channel/UC3imX_9eaMl6-NuokFyHH0w'
                  target='_blank'>
                  <img
                    src={'https://res.cloudinary.com/dljcvcx8l/image/upload/v1586203332/hana_icon_bsuu06.jpg'}
                    className='testim-person-img'
                  />
                  <div className='testim-person-signature'>
                    <div className='testim-link-row'>
                      <div className='testim-person-name'>Hana Milly</div>
                      <img
                        src={require('../../images/yt-icon.png')}
                        className='testim-yt-icon'
                      />
                    </div>
                    <div className='testim-person-descr'>InShape</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='benefits-section'>
          <div className='benefits-section-title'>What you get</div>
          <div className='benefit-area'>
            <div className='mobile-only-benefit-img-area'>
              <img
                src={require('../../images/benefit-workout-exp.png')}
                className='benefit-workout-exp-img'
              />
            </div>
            <div className='benefit-text-area'>
              <div className='benefit-title'>Best-in-class mobile workout experience</div>
              <div className='benefit-descr'>Your users can follow your workouts anytime, anywhere. And Trybe is the only platform that gives your users exercise modifications for deep personalization - keeping them highly engaged.</div>
            </div>
            <div className='benefit-area-midspace'></div>
            <div className='benefit-img-area-non-mobile'>
              <img
                src={require('../../images/benefit-workout-exp.png')}
                className='benefit-workout-exp-img'
              />
            </div>
          </div>
          <div className='benefit-area'>
            <div className='benefit-img-area-non-mobile'>
              <img
                src={require('../../images/benefit-get-paid.png')}
                className='benefit-get-paid'
              />
            </div>
            <div className='mobile-only-benefit-img-area'>
              <img
                src={require('../../images/benefit-get-paid.png')}
                className='benefit-get-paid'
              />
            </div>
            <div className='benefit-area-midspace'></div>
            <div className='benefit-text-area'>
              <div className='benefit-title'>Earn recurring revenue</div>
              <div className='benefit-descr'>We take care of membership access and subscription payments so you can focus on your content. Plus we work with Stripe so you get paid instantly.</div>
            </div>
          </div>
          <div className='benefit-area'>
            <div className='mobile-only-benefit-img-area'>
              <img
                src={require('../../images/benefit-your-content.png')}
                className='benefit-your-content'
              />
            </div>
            <div className='benefit-text-area'>
              <div className='benefit-title'>Only your content</div>
              <div className='benefit-descr'>You get a dedicated space with your content and only your content. We do not promote other creators to your audience.</div>
            </div>
            <div className='benefit-area-midspace'></div>
            <div className='benefit-img-area-non-mobile'>
              <img
                src={require('../../images/benefit-your-content.png')}
                className='benefit-your-content'
              />
            </div>
          </div>
        </div>
        <div className='creator-focus-section'>
          <div className='section-title'>Creator Showcase</div>
          <div className='metas-area'>
            <div className='meta-area'>
              <div className='meta-container'>
                <div className='meta-title'>Creator</div>
                <a
                  className='testim-person-row'
                  href='https://www.youtube.com/channel/UCU0DZhN-8KFLYO6beSaYljg'
                  target='_blank'>
                  <img
                    src={'https://res.cloudinary.com/dljcvcx8l/image/upload/v1586204134/Tom_Icon_lsge3u.jpg'}
                    className='testim-person-img'
                  />

                  <div className='testim-person-signature'>
                    <div className='testim-link-row'>
                      <div className='testim-person-name'>Tom Merrick</div>
                      <img
                        src={require('../../images/yt-icon.png')}
                        className='testim-yt-icon'
                      />
                    </div>
                    <div className='testim-person-descr'>Bodyweight Warrior</div>
                  </div>
                </a>
              </div>
            </div>
            <div className='vert-line'></div>
            <div className='meta-area'>
              <div className='meta-container'>
                <div className='meta-title'>Previous solution</div>
                <div className='meta-text-val'>Membership website</div>
                <div className='meta-text-val'>with workouts</div>
              </div>
            </div>
            <div className='vert-line'></div>
            <div className='meta-area'>
              <div className='meta-container'>
                <div className='meta-title'>Result</div>
                <div className='meta-text-val'>1 year in, increased</div>
                <div className='meta-text-val'>revenue by 17x</div>
              </div>
            </div>
          </div>
          <div className='focus-chart-container'>
            <img
              src={require('../../images/tom-focus-chart.svg')}
              className='tom-focus-chart'
            />
          </div>
        </div>
        <div className='how-it-works-section'>
          <div className='section-title'>How it works</div>
          <div className='steps-area'>
            <div className='step-card'>
              <img
                src={require('../../images/upload.svg')}
                className='how-it-works-img'
              />
              <div className='step-title'>Step 1</div>
              <div className='step-descr'>Upload your content</div>
            </div>
            <div className='mid-space'></div>
            <div className='step-card'>
              <div className='share-img-container'>
                <img
                  src={require('../../images/share.svg')}
                  className='share-img'
                />
              </div>
              <div className='step-title'>Step 2</div>
              <div className='step-descr'>Share with your audience</div>
            </div>
            <div className='mid-space'></div>
            <div className='step-card'>
              <img
                src={require('../../images/earn.svg')}
                className='how-it-works-img'
              />
              <div className='step-title'>Step 3</div>
              <div className='step-descr'>Earn sustainable income</div>
            </div>
          </div>
        </div>
        <div className='pricing-section'>
          <div className='title'>We succeed only</div>
          <div className='title'>when you suceed</div>
          <div className='pricing-descr'>It’s free to start and we are paid only when you earn revenue on Trybe.</div>
          <img
            src={require('../../images/pricing-chart.svg')}
            className='pricing-chart-img'
          />
        </div>
        <div className='final-cta-section'>
          <div className='final-cta-text'>Start Your Trybe.</div>
          <button
            type='button'
            className='start-button'
            onClick={ this.onClickStart }>
            GET STARTED
          </button>
        </div>
        <div className='footer-section'>
          <div className='footer-content'>
            <div className='download-app-area'>
              <div className='download-app-content'>
                <div className='logo-row'>
                  <img
                    src={require('../../images/trybe-logo-white.svg')}
                    className='logo-white'
                  />
                  <div className='logo-text'>TRYBE</div>
                </div>
                <div className='primary-text'>Try our app free</div>
                <div className='descr-text'>See why your users will love it</div>
                <div className='app-stores-row'>
                  <img
                    src={require('../../images/appStore.svg')}
                    className='app-store-img'
                    onClick={this.onClickApp}
                  />
                  <img
                    src={require('../../images/googlePlay.svg')}
                    className='google-play-img'
                    onClick={this.onClickApp}
                  />
                </div>
                <div className='social-media'>

                <a href={'https://www.instagram.com/trybe_fitness'}>
                  <img
                    src={require('../../images/IG_Logo.png')}
                    style={{height: 36, marginRight: 8}}
                  />
                </a>
                  <a href={'https://www.facebook.com/trybefitness/'}>
                    <img
                      src={require('../../images/FB_Logo.png')}
                      style={{height: 36, marginRight: 8}}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className='about-us-area'>
              <div className='column-align-left'>
                <div className='primary-text'>About us</div>
                <div className='descr-text'>Trybe is a San Francisco-based startup. We are passionate about health and fitness, and our mission is to give fitness creators financial freedom so they can continue creating positive content.
                </div>
              </div>
            </div>
          </div>
        </div>
        { this.state.showModal ?
          <div className='modal-container'>
            <div className='modal-card'>
              { this.state.submitted ?
                <div className='card-content-container'>
                  <img
                    className='close-icon'
                    src={require('../../images/closeGrey.svg')}
                    onClick={ this.onClickCloseModal }
                  />
                  <div className='submitted-conf'>
                    <img
                      className='conf-icon'
                      src={require('../../images/confirmationCheckmark.png')}
                    />
                    Thank you for expressing your interest. Our team will get back to your shortly at {this.state.email}.
                  </div>
                </div>
                :
                <div className='card-content-container'>
                  <img
                    className='close-icon'
                    src={require('../../images/closeGrey.svg')}
                    onClick={ this.onClickCloseModal }
                  />
                  <input type='text'
                    className='text-input'
                    placeholder='Name'
                    value={this.state.name}
                    onChange={ this.onEnterName }
                  />
                  <input type='text'
                    className='text-input'
                    placeholder='Email address'
                    value={this.state.email}
                    onChange={ this.onEnterEmail }
                  />
                  <div className='privacy-text'>We respect your privacy and will not share your email.
                  </div>
                  <button
                    type='button'
                    className='submit-button'
                    onClick={ this.onClickSubmit }>
                    Request Invite
                  </button>
                </div>
              }
            </div>
          </div>
          : null
        }
      </div>
    );
  }
}

SalesPage.displayName = 'SalesPage';

export default SalesPage;


// WEBPACK FOOTER //
// ./src/components/landingPages/SalesPage.js